(() => {
  'use strict';
  const giftProductId = 9704202469635;
  const giftVariants = new Set([49732186865923, 49732186898691, 49732186931459, 49732186964227]);
  const marker = '33919157-0';
  const root = window.Shopify?.routes?.root || '/';
  const request = window.fetch.bind(window);
  const products = new Map();
  let pending;
  let timer;

  const isGift = (line) => Number(line.product_id) === giftProductId || giftVariants.has(Number(line.variant_id || line.id));
  const hasBuyTwo = (cart) => {
    const applications = [...(cart.cart_level_discount_applications || [])];
    for (const line of cart.items) {
      for (const allocation of line.line_level_discount_allocations || []) applications.push(allocation.discount_application);
      for (const discount of line.discounts || []) applications.push(discount);
    }
    return applications.some((discount) => /^buy\s*2\s*[,—–-]?\s*save\s*20%$/i.test((discount?.title || '').trim()));
  };

  async function getProduct(handle) {
    if (!products.has(handle)) {
      const response = await request(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Gift eligibility could not be verified');
      products.set(handle, await response.json());
    }
    return products.get(handle);
  }

  async function reconcile() {
    if (pending) return pending;
    pending = (async () => {
      const response = await request(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Cart could not be verified');
      let cart = await response.json();
      const gifts = cart.items.filter(isGift);
      if (!gifts.length) return cart;
      let eligible = false;
      for (const line of cart.items.filter((item) => !isGift(item) && item.final_line_price > 0)) {
        const product = await getProduct(line.handle);
        const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map((tag) => tag.trim());
        if (tags.includes('free-gift-eligible') && !tags.includes('final-stock')) eligible = true;
      }
      const updates = {};
      let kept = false;
      for (const line of gifts) {
        const allowed = eligible && !hasBuyTwo(cart) && line.properties?._apphero_gift === marker && !kept;
        const quantity = allowed ? 1 : 0;
        if (allowed) kept = true;
        if (line.quantity !== quantity) updates[line.key] = quantity;
      }
      if (Object.keys(updates).length) {
        const updated = await request(`${root}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!updated.ok) throw new Error('Gift cart protection could not update the cart');
        cart = await updated.json();
        setTimeout(() => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })), 0);
      }
      return cart;
    })();
    try { return await pending; } finally { pending = undefined; }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        if (pending) await pending;
        await reconcile();
      } catch {}
    }, 100);
  }

  window.fetch = async function (...args) {
    const response = await request(...args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
    if (url && /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(url)) schedule();
    return response;
  };

  const checkoutSelector = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]';
  async function verifyCheckout(event, target, submitter) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (target.dataset.giftChecking) return;
    target.dataset.giftChecking = 'true';
    try {
      if (pending) await pending;
      await reconcile();
      if (target.tagName === 'FORM') {
        target.dataset.giftVerified = 'true';
        target.requestSubmit(submitter || undefined);
        delete target.dataset.giftVerified;
      } else if (target.tagName === 'A') {
        window.location.assign(target.href);
      } else if (target.form) {
        target.form.dataset.giftVerified = 'true';
        target.form.requestSubmit(target);
        delete target.form.dataset.giftVerified;
      }
    } catch {
      window.location.assign(`${root}cart`);
    } finally { delete target.dataset.giftChecking; }
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest?.(checkoutSelector);
    if (target && !target.form?.dataset.giftVerified) verifyCheckout(event, target);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.dataset.giftVerified) return;
    if (event.submitter?.matches(checkoutSelector)) verifyCheckout(event, event.target, event.submitter);
  }, true);
  for (const name of ['cart:change', 'cart:refresh', 'cart-drawer:refreshed', 'shopify:section:load']) document.addEventListener(name, schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  if (document.readyState !== 'loading') schedule();
})();
